import React from 'react';

const verdictToStyle = (verdict) => {
  switch (verdict) {
    case 'OK':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'En forme':
      return 'bg-emerald-100 text-emerald-800 border-emerald-200';
    case 'Sur-intensité':
      return 'bg-orange-100 text-orange-800 border-orange-200';
    case 'Sous-charge':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'Risque blessure':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'Données insuffisantes':
    default:
      return 'bg-gray-100 text-gray-700 border-gray-200';
  }
};

export default function CoachVerdictBadge({ verdict, label }) {
  if (!verdict && !label) return null;
  const cls = verdictToStyle(verdict);
  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-extrabold border ${cls}`}>
      {label || verdict}
    </span>
  );
}


